import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { ComponentService } from 'src/app/service/component.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { DealerPriceCheckerService } from 'src/app/utility/dealer-price-checker.service';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';
import { SlickCarouselUtilService } from '../../../utility/slick-carousel.util';

@Component({
  selector: 'app-product-carousel-big',
  templateUrl: './product-carousel-big.component.html',
  styleUrls: ['./product-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductCarouselBigComponent implements OnInit, OnDestroy {
  slickConfig: any;
  showSrp = false;
  srpSubscription$: Subscription;
  hasDealerPrice = true;
  dealerPriceCheckerSubscription$: Subscription;
  businessType: string;

  constructor(
    private deviceService: DeviceDetectorService,
    protected componentService: ComponentService,
    protected dealerPriceService: DealerPriceService,
    protected cdr: ChangeDetectorRef,
    private dealerPriceChecker: DealerPriceCheckerService,
    private currentBusinesstype: CurrentBusinessType,
    private storageService: StorageService
  ) {
    const slickConfig = new SlickCarouselUtilService();
    const slickObj = slickConfig.defaultConfig;
    slickObj.slidesToShow = 4;
    slickObj.slidesToScroll = 4;
    if (!this.deviceService.isDesktop()) {
      slickObj.arrows = false;
    }
    this.slickConfig = slickObj;
  }

  @Input() items: any;
  @Input() dealerPrices: DealerPrice[];

  ngOnInit() {
    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });

    this.dealerPriceCheckerSubscription$ = this.componentService.hasDealerPrice$.subscribe((hasDealerPrice) => {
      this.hasDealerPrice = hasDealerPrice;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
    this.businessType = this.currentBusinesstype.getBusinessType();
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  dealerPrice(productCode: string): string {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  getImageRendition(image: any) {
    let size: string;
    if (this.deviceService.isDesktop()) {
      size = ShimanoUtilMethod.imageRendition(295);
    } else {
      size = ShimanoUtilMethod.imageRendition(177);
    }
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  ngOnDestroy() {
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
    if (this.dealerPriceCheckerSubscription$) {
      this.dealerPriceCheckerSubscription$.unsubscribe();
    }
  }
}
